<template>
  <div class="con">
    <el-input class="item" placeholder="请输入关键字" v-model="form.keywords" clearable>
    </el-input>
    <!-- <el-cascader class="item" placeholder="请选择区域" v-model="form.areaName" :options="provs"
      :props="{ expandTrigger: 'hover' }" @change="handleChange"></el-cascader> -->
    <el-select v-model="form.address" placeholder="请选择">
      <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <!-- <el-select
      class="item"
      v-model="form.case_tyep"
      multiple
      placeholder="请选择案例类型"
    >
      <el-option
        v-for="item in option_type"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select class="item" v-model="form.hotPoint" multiple placeholder="请选择案例">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select> -->
    <el-button class="item" type="primary" @click="searchData">点击搜索<i class="el-icon-search"></i></el-button>
  </div>
</template>
  
<script>
import cityData from "@/assets/city";
import cityJson from "./map.json"
import { createMapOptions } from "@/utils/mapLocale";
export default {
  name: "SearchCase",
  props: {
    data: Object,
  },
  data() {
    return {
      form: {},
      provs: [],
      option_type: [
        {
          value: "0",
          label: "基础测绘",
        },
        {
          value: "1",
          label: "大比例尺测绘",
        },
        {
          value: "2",
          label: "航测",
        },
      ],
    };
  },
  mounted() {
    this.provs = createMapOptions(cityJson, this.$store.state.language);
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    searchData() {
      console.log("searchData");
      this.$emit("searchData", this.form);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.con {
  font-size: 20px;
  height: 50px;
  display: flex;
  margin: auto;

  .item {
    margin: 0 10px;
    color: #fff;
  }
}

:deep .el-input__inner {
  height: 50px;
  width: 150px;
  font-size: 16px;
}

.el-button--primary {
  font-size: 16px;
  padding: 0 40px;
  background-color: #e02d3f;
  border: none;
}

.el-icon-search {
  margin-left: 20px;
}
</style>
  
